import { Injectable } from '@angular/core';
import { differenceInCalendarDays, parseISO } from 'date-fns';
import { UserType } from 'src/app/shared/constants';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  public isAuthenticated() {
    return localStorage.getItem('world_prays_token');
  }

  public setIsGuest(isGuest: boolean) {
    localStorage.setItem('world_prays_is_guest', isGuest ? '1' : '0');
  }

  public isGuest() {
    const flag = localStorage.getItem('world_prays_is_guest');
    if (flag !== null) {
      return flag === '1';
    }
    const fallback = this.user?.type?.code === 'guest';
    this.setIsGuest(fallback);
    return fallback;
  }

  public clear(){
    return localStorage.clear();
  }

  public get shouldRefreshToken() {
    const tokenExpirationDate = localStorage.getItem('token_expiration_date') as string;
    if (tokenExpirationDate) {
      const expirationDate = parseISO(tokenExpirationDate);
      const days = differenceInCalendarDays(expirationDate, new Date());
      return days <= 2;
    }
    return false;
  }

  public setUser(user: UserType) {
    if (user.id) {
      localStorage.setItem('world_prays_user', JSON.stringify(user));
    }
  }

  public get user() {
    const user: UserType = JSON.parse(localStorage.getItem('world_prays_user') as string);
    if (user?.id) {
      return user;
    }
    return undefined;
  }

  public get organization() {
    if (this.user && this.user.organization) {
      return this.user.organization;
    }
    return undefined;
  }

}